import React from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";

import Button from "../ButtonV1";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import reactHtmlParser from "react-html-parser";
import ReactHtmlParser from "react-html-parser";
import {darkBlue, hover, white} from "../../styles/globalStyleVars";
import Title from "../Title";
import {Img} from "../Img";

const AboutPartex = ({data}) => {
    console.log(data?.description);
    return (
        <StyledComponent  className='about-partex pt-200 pb-200 parallax-img' >
            <Container >
                <Row>
                    <Img data-speed={30} src={'images/static/map.svg'}/>
                    <Col md={12}>
                        <Title text={data?.title ? data?.title :'About Us'} margin={'0 0 60px 0'} />
                    </Col>
                    <Col md={data?.description? 5: 12} className={'counter_left pr-0'}>
                        <div className="content">
                            {
                                data?.subtitle && <h3 className={'split-up'}>{data?.subtitle}</h3>
                            }

                        </div>
                    </Col>
                    <Col md={{span: 5, offset: data?.description ?2 : ""}}>
                        <div className="content ">
                            {data?.description && ReactHtmlParser(data?.description)}
                            <Button icon src={'/about'} color={`${white}`} hoverColor={`${white}`} text={'Learn More'} margin={'40px 0px 0px 0'}/>
                        </div>
                    </Col>


                </Row>
            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  background: ${darkBlue};
  position: relative;
  padding-bottom: 350px !important;
  .row {
    //position: relative;
  }
  .global-image{
    overflow: visible;
  }

  img {
    position: absolute;
    top: 100px;
    bottom: 0;
    right: 0;
    left: unset;
    height: 70%;
    width: 60%;
    object-fit: unset;
  }

  .upper-title {
    width: 50%;
    margin: 0 0 20px 0;
  }

  h3 {
    margin: 0 0 80px 0;

    span {
      color: #E50019;
    }
  }

  p {
    margin: 0 0 40px 0;
  }

  .counter-item {
    h3 {
      font-size: 72px;
      line-height: 84px;
      font-weight: 400;
      margin: 0;
    }

    p {
      margin: 0;
    }

    &:nth-child(1) {
      margin-bottom: 40px;
    }
  }

  @media (max-width: 991px) {
    img {
      top: unset;
      bottom: 50px;
      right: 15px;
      left: 15px;
      height: unset;
      width: calc(100% - 30px);
      object-fit: unset;
    }

    .upper-title {
      width: 100%;
    }

    .btn-col {
      margin-bottom: 80px;
    }

    .counter-item {
      &:nth-child(3) {
        margin-bottom: 40px;
      }
    }
  }

`;

export default AboutPartex;
